import { Card, Collapse, Space } from "antd";
import { Actuacion } from "./Actuacion";
import Convenio from "./Convenio";
import { Fragment, useEffect, useState } from "react";
import { convenioService } from "../../../../_services/convenios.service";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../../redux/Loading/actions";
import { actuacionesService } from "../../../../_services/actuaciones.service";
import { EditOutlined, DeleteOutlined, FileOutlined } from "@ant-design/icons";
import { Button, Table } from "react-bootstrap";
import Swal from "sweetalert2";
import { gestionService } from "../../../../_services/gestionLegal.service";
import { useUser } from "../../../../hooks/useUser";
import { RecursosComercios } from "../../../../constants";
const { Panel } = Collapse;

const RowData = ({ data, handleOpen, reloadData, handleConvenio, handleOpenPDF, type, abogado }) => {
  const dispatch = useDispatch();
  const user = useUser();
  const [convenios, setConvenios] = useState([]);
  const [actuaciones, setActuaciones] = useState([]);
  const [base, setBase] = useState([]);
  const [recursosAct, setRecursosAct] = useState([]);

  const { imponible, recurso, codexterno } = data;

  const getConvenios = async (abogado) => {
    try {
      if (type === "comercios") {
        let response = [];

        for (const e of RecursosComercios) {
          const res = await convenioService.getListConvenio({
            recurso: e,
            imponible,
            abogado: abogado || codexterno
          });

          if (typeof res !== "string") {
            response.push(res);
          }
        }
      }
      else {
        let response = await convenioService.getListConvenio({
          recurso,
          imponible,
          abogado: abogado || codexterno
        });

        if (response && Array.isArray(response)) {
          setConvenios(response);
        }
        else {
          setConvenios([]);
        }
      }
    }
    catch (err) {
      console.log(err);
    }
  };

  const getActuaciones = async () => {
    try {
      const { imponible, recurso, codexterno } = data;


      let response = [];
      let recs = [];
      if (type === "comercios") {
        for (const e of RecursosComercios) {
          dispatch(setLoading(true));
          const res = await actuacionesService.actuacionesxImp({
            recurso: e,
            imponible,
            abogado: abogado || codexterno
          });

          if (res?.length) {
            recs.push(e);
            response.push(res[0]);
          }
        }

        setRecursosAct(recs);
      }
      else {
        response = await actuacionesService.actuacionesxImp({
          recurso,
          imponible,
          abogado: abogado || codexterno
        });
      }

      if (response && Array.isArray(response)) {
        let promises = response.map((actuacion) => {
          dispatch(setLoading(true));
          if (actuacion.tipo_nombre === "Cédula") {
            return actuacionesService.getActuacionDocumento(actuacion.id)
              .then((doc) => {
                if (doc?.documento) {
                  return {
                    ...actuacion,
                    documento: doc.documento
                  };
                } else {
                  return actuacion;
                }
              })
              .catch(err => {
                console.log(err);
                return err;
              });
          } else {
            return actuacion;
          }
        });

        let res = await Promise.all(promises);
        setActuaciones(res);
        dispatch(setLoading(false));
      }
      else {
        setActuaciones([]);
        dispatch(setLoading(false));
      }
    }
    catch (err) {
      console.log(err);
    }
  };

  const getBase = async () => {
    try {
      const { imponible } = data;

      let response = await gestionService.basexImp({
        imponible,
        tipo: type === "comercios" ? "C" : "I"
      });

      if (response && Array.isArray(response)) {
        setBase(response);
      }
      else {
        setBase([]);
      }
    }
    catch (err) {
      console.log(err);
    }
  };

  const getData = async () => {
    dispatch(setLoading(true));
    try {
      // if (user.abogado === "A00") {
      //   let gestion = await gestionService.getGestionList({
      //     nro_imponible: imponible,
      //     recurso
      //   });

      //   let codexterno = "";
      //   if (gestion?.length) {
      //     codexterno = gestion[0].codexterno;
      //   }

      //   getConvenios(user.abogado || codexterno);
      //   getActuaciones(user.abogado || codexterno);
      //   getBase();
      //   dispatch(setLoading(false));
      // } else {
      getConvenios();
      getActuaciones();
      getBase();
      dispatch(setLoading(false));
      // }
    }
    catch (err) {
      console.log(err);
      dispatch(setLoading(false));
    }
  };


  useEffect(() => {
    getData();
  }, []);

  const handleDelete = async (e, data) => {
    e.stopPropagation();

    Swal.fire({
      title: "¿Esta seguro de eliminar la actuación?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          dispatch(setLoading(true));
          let response = await gestionService.createActuacion({
            proceso: "B",
            id_etapa: data.id,
            tp_id: data.tp_id,
            gp_id: data.gp_id
          });

          if (typeof response[0] === "string") {
            dispatch(setLoading(false));
            Swal.fire("Error!", "Ocurrio un error, intentelo nuevamente.", "error");
          }
          else {
            dispatch(setLoading(false));
            Swal.fire({
              title: "Exito!",
              text: "Las actuaciones se eliminarón correctamente.",
              icon: "success",
              didClose: () => reloadData()
            });
          }
        }
        catch (err) {
          console.log(err);
          dispatch(setLoading(false));
          Swal.fire("Error!", "Ocurrio un error, intentelo nuevamente.", "error");
        }
      }
    });
  };

  const handleDeleteConvenio = async (convenio) => {
    try {
      if (convenio) {
        Swal.fire({
          title: "¿Esta seguro de eliminar este convenio?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
          reverseButtons: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            setLoading(true);
            let response = await convenioService.deleteConvenio({ convenio });

            if (response && response[0].estado === 0) {
              setLoading(false);

              return Swal.fire({
                title: "Exito!",
                text: "Se eliminó correctamente.",
                icon: "success",
                didClose: () => reloadData()
              });
            }
            else {
              setLoading(false);
              return Swal.fire(
                "Error!",
                "Ocurrio un error, intentelo nuevamente.",
                "error"
              );
            }
          }
        });
      }

    }
    catch (err) {
      console.log(err);
      return Swal.fire(
        "Error!",
        "Ocurrio un error, intentelo nuevamente.",
        "error"
      );
    }
  };

  return (
    <Space className="actuaciones" direction="vertical" size="middle" style={{ display: "flex" }}>
      <Card title="DATOS" size="default">
        {
          base.length ?
            <Table className="subtable" striped bordered hover>
              <thead>
                <tr>
                  <th>Domicilio</th>
                  <th>Barrio</th>
                  <th>Nomenclatura</th>
                  <th>Partida</th>
                  <th>Nombre</th>
                </tr>
              </thead>
              <tbody>
                {base.length && base.map((e, i) => {
                  const {
                    CALLE, NRO, PISO, DEPT,
                    BARRIO,
                    PAR_PROVINCIAL,
                    CIRCUNS,
                    SECCION,
                    CHACRA_NRO,
                    CHACRA_LET,
                    QUINTA_NRO,
                    QUINTA_LET,
                    FRACCION_NRO,
                    FRACCION_LET,
                    MANZANA_NRO,
                    MANZANA_LET,
                    PARCELA_NRO,
                    PARCELA_LET,
                    UNI_FUNCIONAL,
                    CONTRIBUYENTE
                  } = e;

                  return <Fragment key={"deudas1-" + i}>
                    <tr>
                      <td><span>{`${CALLE || ""} ${NRO || ""} ${PISO ? ` - PISO: ${PISO}` : ""} ${DEPT ? `DEPT: ${DEPT}` : ""}`}</span></td>
                      <td><span>{BARRIO}</span></td>
                      <td>
                        <span>{`
                        ${CIRCUNS ? `CIRCUNS: ${CIRCUNS}` : ""} ${SECCION ? `- SECCION: ${SECCION}` : ""} ${CHACRA_NRO ? `- CHACRA_NRO: ${CHACRA_NRO}` : ""} ${CHACRA_LET ? `- CHACRA_LET: ${CHACRA_LET}` : ""}
                        ${QUINTA_NRO ? `- QUINTA_NRO: ${QUINTA_NRO}` : ""} ${QUINTA_LET ? `- QUINTA_LET: ${QUINTA_LET}` : ""} ${FRACCION_NRO ? `- FRACCION_NRO: ${FRACCION_NRO}` : ""} ${FRACCION_LET ? `- FRACCION_LET: ${FRACCION_LET}` : ""}
                        ${MANZANA_NRO ? `- MANZANA_NRO: ${MANZANA_NRO}` : ""} ${MANZANA_LET ? `- MANZANA_LET: ${MANZANA_LET}` : ""} ${PARCELA_NRO ? `- PARCELA_NRO: ${PARCELA_NRO}` : ""} ${PARCELA_LET ? `- PARCELA LET: ${PARCELA_LET}` : ""}
                        ${UNI_FUNCIONAL ? `- SUBPARCELA: ${UNI_FUNCIONAL}` : ""}
                      `
                        }
                        </span>
                      </td>
                      <td><span>{PAR_PROVINCIAL}</span></td>
                      <td><span>{CONTRIBUYENTE}</span></td>
                    </tr>
                  </Fragment>;
                })
                }
              </tbody>
            </Table>
            : ""
        }
      </Card>
      <Card title="ACTUACIONES" size="default">
        {
          actuaciones.length ? type === "comercios" ?
            recursosAct.map((r) => {
              return (
                <Collapse key={`${imponible}-${r}`} style={{ margin: 20 }}>
                  <Panel
                    header={`RECURSO - ${r}`}
                  >
                    {actuaciones.filter(a => a.recurso === r).map((actuacion) => {
                      return (
                        <Collapse key={actuacion.id} style={{ margin: 20 }}>
                          <Panel
                            header={
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <div>
                                  <span>{`${actuacion?.gp_nombre}, ${actuacion?.tipo_nombre} - ${actuacion.ingreso}`}</span>
                                </div>
                                {("A00" !== user?.abogado && data?.codexterno !== user?.abogado) || actuacion?.vigente === "0" ?
                                  null :
                                  (
                                    <div className="d-flex">
                                      {actuacion.documento ? (
                                        <div>
                                          <Button
                                            className="d-flex align-items-center ml-2"
                                            variant="contained"
                                            style={{
                                              borderColor: "#d9d9d9"
                                            }}
                                            onClick={() => handleOpenPDF(actuacion)}
                                          >
                                            <FileOutlined />
                                          </Button>
                                        </div>
                                      ) : ""}
                                      <div>
                                        <Button
                                          className="d-flex align-items-center ml-2"
                                          variant="contained"
                                          style={{
                                            borderColor: "#d9d9d9"
                                          }}
                                          onClick={() => handleOpen(actuacion, data)}
                                        >
                                          <EditOutlined />
                                        </Button>
                                      </div>
                                      <div>
                                        <Button
                                          className="d-flex align-items-center ml-2"
                                          variant="danger"
                                          style={{
                                            borderColor: "#d9d9d9"
                                          }}
                                          onClick={(event) => handleDelete(event, actuacion)}
                                        >
                                          <DeleteOutlined />
                                        </Button>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            }
                          >
                            <Actuacion id={actuacion.id} key={actuacion.id} />
                          </Panel>
                        </Collapse>
                      );
                    })}
                  </Panel>
                </Collapse>
              );
            })
            :
            actuaciones.map((actuacion) => {
              return (
                <Collapse key={actuacion.id} style={{ margin: 20 }}>
                  <Panel
                    //  header={`${e?.gp_nombre}, ${e?.tipo_nombre} - ${e.ingreso}`} key={e.id}
                    header={
                      <div className="d-flex align-items-center justify-content-between w-100">
                        <div>
                          <span>{`${actuacion?.gp_nombre}, ${actuacion?.tipo_nombre} - ${actuacion.ingreso}`}</span>
                        </div>
                        {("A00" !== user?.abogado && data?.codexterno !== user?.abogado) || actuacion?.vigente === "0" ?
                          null :
                          (
                            <div className="d-flex">
                              {actuacion.documento ? (
                                <div>
                                  <Button
                                    className="d-flex align-items-center ml-2"
                                    variant="contained"
                                    style={{
                                      borderColor: "#d9d9d9"
                                    }}
                                    onClick={() => handleOpenPDF(actuacion)}
                                  >
                                    <FileOutlined />
                                  </Button>
                                </div>
                              ) : ""}
                              <div>
                                <Button
                                  className="d-flex align-items-center ml-2"
                                  variant="contained"
                                  style={{
                                    borderColor: "#d9d9d9"
                                  }}
                                  onClick={() => handleOpen(actuacion, data)}
                                >
                                  <EditOutlined />
                                </Button>
                              </div>
                              <div>
                                <Button
                                  className="d-flex align-items-center ml-2"
                                  variant="danger"
                                  style={{
                                    borderColor: "#d9d9d9"
                                  }}
                                  onClick={(event) => handleDelete(event, actuacion)}
                                >
                                  <DeleteOutlined />
                                </Button>
                              </div>
                            </div>
                          )}
                      </div>
                    }
                  >
                    <Actuacion id={actuacion.id} key={actuacion.id} />
                  </Panel>
                </Collapse>
              );
            })
            : ""
        }
      </Card>
      <Card title="CONVENIOS" size="default">
        {
          convenios.length ?
            convenios.map(e => {
              return (
                <Collapse
                  key={e.convenio}
                  style={{ margin: 20 }}
                >
                  <Panel
                    key={e.convenio}
                    header={
                      <div className="d-flex align-items-center justify-content-between w-100">
                        <div>
                          <span>{`${e?.convenio}`}</span>
                        </div>
                        {("A00" !== user?.abogado && data?.codexterno !== user?.abogado) || e?.estado === "0" ?
                          null : (
                            <div className="d-flex">
                              <div>
                                <Button
                                  className="d-flex align-items-center ml-2"
                                  variant="contained"
                                  style={{
                                    borderColor: "#d9d9d9"
                                  }}
                                  onClick={() => handleConvenio({
                                    id: e.convenio,
                                    imponible,
                                    recurso
                                  })}
                                >
                                  <EditOutlined />
                                </Button>
                              </div>
                              <div>
                                <Button
                                  className="d-flex align-items-center ml-2"
                                  variant="danger"
                                  style={{
                                    borderColor: "#d9d9d9"
                                  }}
                                  onClick={() => handleDeleteConvenio(e)}
                                >
                                  <DeleteOutlined />
                                </Button>
                              </div>
                            </div>
                          )}
                      </div>
                    }
                  >
                    <Convenio convenioId={e.convenio} key={e.convenio} />
                  </Panel>
                </Collapse>
              );
            })
            : ""
        }
      </Card>
    </Space>
  );
};



export default RowData;